export default {
  /**
   *  存储localStorage
   */
  set(name: string, content: any) {
    if (!name) {
      return;
    }
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
  },

  /**
   * 获取localStorage
   */
  get(name: string) {
    if (!name) {
      return '';
    }
    const content = window.localStorage.getItem(name);
    return content;
  },

  /**
   * 删除localStorage
   */
  remove(name: string) {
    if (!name) {
      return;
    }
    window.localStorage.removeItem(name);
  },
};
